/* A few line icons for metric chips and section heads (ADR-042): inline SVG, 20px, stroke in the
   current colour, hidden from screen readers (the label next to each says what it is). No icon library. */
import type { ReactNode } from 'react';

function Icon({ children }: { children: ReactNode }) {
  return (
    <svg
      className="d-icon"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export const IconAlert = () => (
  <Icon>
    <path d="M12 3 2.5 20h19L12 3z" />
    <path d="M12 10v4" />
    <path d="M12 17.5v.01" />
  </Icon>
);
export const IconClipboard = () => (
  <Icon>
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <path d="M9 4h6v3H9z" />
    <path d="M9 12h6M9 16h4" />
  </Icon>
);
export const IconWallet = () => (
  <Icon>
    <rect x="3" y="6" width="18" height="14" rx="2" />
    <path d="M3 10h18" />
    <path d="M16 15h2" />
  </Icon>
);
export const IconDevice = () => (
  <Icon>
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <path d="M11 18h2" />
  </Icon>
);
export const IconPulse = () => (
  <Icon>
    <path d="M3 12h4l3-7 4 14 3-7h4" />
  </Icon>
);
